export default __webpack_public_path__ + "static/media/placeholder-laptop.5a2c977a.svg";